import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import WithOverlay from "../../popups/withOverlayHoc";
import {LOOK_OVERLAYS} from "../core/constants";
import LookOverlayQuestionButtons from "./lookOverlayQuestionsButtons";
import {isIframe} from "../../../misc/helpers";


const LookOverlayQuestions = (props) => {

  const {lookOverlayOpened, fabricatorData} = props;

  const stylePopups = [LOOK_OVERLAYS.exit, LOOK_OVERLAYS.print];

  if (!stylePopups.some(popupType => popupType === lookOverlayOpened)) {
    return null
  }

  const isLixil = isIframe() && fabricatorData.isLixil;

  let titleString = lookOverlayOpened;
  if (!isLixil && fabricatorData.websiteUrl) {
    titleString = titleString + ".short";
  }

  return (
    <WithOverlay>
      {(hideOverlay) => (
        <div className={"look-question look-question--" + lookOverlayOpened}>
          <div className="look-question__content">
            <h2 className={"look-question__title h2 h2--regular" + (lookOverlayOpened === LOOK_OVERLAYS.intro ? " bold" : "")}>
              <FormattedMessage id={`overlays.${titleString}.title`}/>
            </h2>
            <p className="look-question__text">
              <FormattedMessage id={`overlays.${lookOverlayOpened}.text`}/>
            </p>
            <LookOverlayQuestionButtons hideOverlay={hideOverlay}/>
          </div>
        </div>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {lookOverlayOpened} = store.lookState;
  const fabricatorData = store.fabricatorState;

  return {
    lookOverlayOpened,
    fabricatorData,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LookOverlayQuestions)
